import React from 'react';
import { DirectionToggle } from '../shared/DirectionToggle';
import { DigitKeypad } from '../shared/DigitKeypad';
import { TickSelector } from '../shared/TickSelector';

interface MatchesDiffersParamsProps {
  direction: 'matches' | 'differs';
  selectedDigit: number;
  tickCount: number;
  onDirectionChange: (direction: 'matches' | 'differs') => void;
  onDigitSelect: (digit: number) => void;
  onTickCountChange: (count: number) => void;
}

const MatchesDiffersParams: React.FC<MatchesDiffersParamsProps> = ({
  direction,
  selectedDigit,
  tickCount,
  onDirectionChange,
  onDigitSelect,
  onTickCountChange
}) => {
  return (
    <>
      <div className="parameter-group">
        <label>Direction</label>
        <DirectionToggle
          leftLabel="Matches"
          rightLabel="Differs"
          selectedDirection={direction}
          onDirectionChange={(dir) => onDirectionChange(dir as 'matches' | 'differs')}
        />
      </div>

      <div className="parameter-group">
        <label>Digit Prediction</label>
        <DigitKeypad
          selectedDigit={selectedDigit}
          onDigitSelect={onDigitSelect}
        />
      </div>

      <div className="parameter-group">
        <label>Tick Count</label>
        <TickSelector
          tickCount={tickCount}
          onTickCountChange={onTickCountChange}
        />
      </div>
    </>
  );
};

export default MatchesDiffersParams;
export { MatchesDiffersParams };
